import { Form } from "react-router-dom";
import { Button as HeadlessUiButton } from "@headlessui/react";
import { Plan, StripePrice } from "src/types";
import { useTranslation } from "react-i18next";

interface Props {
  buttonSubtitle: string;
  currency: string;
  isSubmitting: boolean;
  periodAmount: number;
  plan: Plan;
  priceId: string | undefined;
  setIsSubmitting: (isSubmitting: boolean) => void;
  stripePrice: StripePrice | undefined;
  timeLeft: string;
}

export default function SubscriptionFormTimer({
  buttonSubtitle,
  currency,
  isSubmitting,
  plan,
  priceId,
  setIsSubmitting,
  stripePrice,
  timeLeft,
}: Props) {
  const handleClick = () => {
    setIsSubmitting(true);
  };
  const { t } = useTranslation();

  return (
    <Form onSubmit={handleClick} method="post" className="flex justify-center">
      <input type="hidden" name="currency" value={currency} />

      <input type="hidden" name="plan" value={plan} />

      <input type="hidden" name="priceId" value={priceId} />

      <input
        type="hidden"
        name="fullPrice"
        value={
          stripePrice?.currency_options[currency].unit_amount_decimal ??
          stripePrice?.unit_amount_decimal
        }
      />

      <HeadlessUiButton
        className="justify-left flex w-full max-w-2xl items-center justify-between"
        disabled={isSubmitting}
        type="submit"
      >
        <div className="text-left">
          <p className="text-sm font-semibold text-black">{buttonSubtitle}</p>
          <p className="text-[24pt] font-bold text-black">{timeLeft}</p>
        </div>

        <span className="flex-shrink-0 uppercase font-bold rounded-full bg-black px-4 py-2 text-white">
          {t("pages.checkout.plans.startNow")}
        </span>
      </HeadlessUiButton>
    </Form>
  );
}
